import { PublicationPreference } from "../models/publication-preference";

export class PublicationsService {
    private static endpoint = '/apic/publications';

    public getPreferences = async (): Promise<Array<PublicationPreference>> => {
        const response = await fetch(PublicationsService.endpoint, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'GET'
        });
        return (await response.json() as any[]).map(PublicationPreference.fromJson);
    };

    public setPreferences = async (preferences: Array<PublicationPreference>): Promise<void> => {
        await fetch(PublicationsService.endpoint, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(preferences)
        });
    }
}